import React from "react";
import PlanForm from "./PlanForm";
import axios from "axios";
import { toast } from "react-toastify"; // ✅ Import toast
import { BACKEND_BASE_URL } from "../../config";

const API_BASE_URL = `${BACKEND_BASE_URL}/api`;

const EditPlan = ({ planData, onSuccess, onCancel }) => {
  const token = localStorage.getItem("authToken");

  const handleEdit = async (data) => {
    try {
      await axios.put(
        `${API_BASE_URL}/subscription/${planData.id}/update/`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Plan updated successfully!"); // ✅ Success toast
      onSuccess();
    } catch (error) {
      console.error("Error editing plan:", error);
      toast.error("Failed to update plan. Please try again."); // ✅ Error toast
    }
  };

  return (
    <PlanForm
      initialData={planData}
      onSubmit={handleEdit}
      onCancel={onCancel}
    />
  );
};

export default EditPlan;
